import store from '../../../../../resources/js/store'

export default function () {
  const Vue = window.vue

  Vue.$store.dispatch('serm/client/domains/fetch')

  Vue.$on('moduleChanged', ({ from, to }) => {
    if (to === 'serm') {
      Vue.$store.dispatch('serm/client/domains/fetch')
    }
  })

  /**
   * Был загружен список доменов клиента.
   * Если домен еще не выбран - выбираем первый из списка всех доменов.
   */
  Vue.$on('serm/domainsLoaded', () => {
    if (store.state.serm.client.domains.domains.length) {
      const selectedDomain = store.state.serm.client.domains.domains.find(domain => domain.sengine === 'y')
      store.dispatch('serm/client/domains/changeSelected', selectedDomain)
      // Получаем список регионов
      store.dispatch('serm/regions/fetch', selectedDomain.url)
    }
  })

  /**
   * После загрузки списка регионов выбираем первый из списка
   */
  Vue.$on('serm/regionsLoaded', () => {
    if (store.state.serm.regions.regions.length) {
      const selectedRegion = store.state.serm.regions.regions[0].id
      store.dispatch('serm/regions/changeSelected', selectedRegion)
    }
  })
}
